import flux from 'flux';

export default class Dispatcher extends flux.Dispatcher {
    register(callback, context) {
        if (typeof callback !== 'function') {
            throw new Error('callback must be a function');
        }

        if (context) {
            callback = callback.bind(context);
        }

        return super.register(callback);
    }

    dispatch(payload) {
        if (!payload) {
            throw new Error('payload must be provided');
        }

        if (typeof payload.actionType !== 'string') {
            throw new Error('actionType must be specified in the payload');
        }

        super.dispatch(payload);
    }

    waitFor(...dispatchTokens) {
        if (!dispatchTokens || !dispatchTokens.length) {
            throw new Error('At least one dispatchToken must be provided');
        }

        super.waitFor(dispatchTokens);
    }
}
